import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/auth';

export function AdminLayout() {
  const { role } = useAuthStore();
  const location = useLocation();

  if (role !== 'admin') {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
